<template lang="pug">
    div(v-if="summaries.length > 0")
        fan-loader(
            v-if="fetchingPagination"
            :loading="fetchingPagination"
            :class="$vuetify.breakpoint.smAndUp ? 'my-4' : null"
            )
                div(slot="loadingMsg" 
                    class="full-width text-xs-center headline my-2") Loading...
        template(
            v-else-if="!fetchingPagination" 
            v-for="summary in summaries"
            )
            PreQualApplicationListTile(
                :id="summary.preQualificationId"
                :providerId="summary.providerPreQualificationId"
                :icon="companyLogo('greensky')"
                :submitDate="summary.submitDate"
                :firstName="summary.consumerFirstName"
                :lastName="summary.consumerLastName"
                :providerStatus="summary.providerStatus"
                :status="summary.status"
                :requestAmount="summary.requestedLoanAmount"
            )
        v-pagination.mt-3(
            :length="pages"
            v-model="page"
            @input="paginate"
            )
</template>

<script>
import {mapState, mapActions} from 'vuex'
import PreQualApplicationListTile from 'Components/PreQualApplicationListTile.vue'
import Lenders from 'Mixins/Lenders'
import FanLoader from 'Components/FanLoader'
export default {
    name: 'pre-qualifications-list',
    components: {
        PreQualApplicationListTile,
        FanLoader
    },
    mixins: [Lenders],
    data(){
        return{
            page: 1,
            fetchingPagination: false
        }
    },
    computed: {
        ...mapState({
            preQualApplications: state => state.user.preQualApplicationHistory,
            dealerId: state => state.user.dealerId
        }),
        summaries(){
            return this.preQualApplications.summaries
        },
        pages(){
            return this.preQualApplications.numberOfPages
        }
    },
    methods: {
        ...mapActions(['loadPreQualApplicationHistory']),
        async paginate(){
            this.fetchingPagination = true
            await this.loadPreQualApplicationHistory({
                limit: 6,
                page: this.page,
                dealerId: this.dealerId
            })
            this.fetchingPagination = false
        },
    }

}
</script>

<style lang="scss" scoped>

</style>